import { OzonRegistrationButton } from '../../components/OzonRegistrationButton';

interface useOzonTriggerPropsProps {
    isShow: Boolean;
    openRegistrationOzon: VoidFunction;
}

/*
 * Возвращает пропсы для компонента тригера (<Trigger/>) выбора интервала доставки Ozon: подпись и кнопки регистрации (десктоп / мобилка).
 *
 * @param props.isShow — показывать ли блок с кнопкой Ozon ID и подписью
 * @param props.openRegistrationOzon — колбэк открытия окна регистрации Ozon ID
 */
export const useOzonTriggerProps = (props: useOzonTriggerPropsProps) => {
    const { isShow, openRegistrationOzon } = props;

    let caption: string | undefined;
    let rightContent: JSX.Element | undefined;

    if (isShow) {
        rightContent = <OzonRegistrationButton onClick={openRegistrationOzon} />;
        caption = 'Для оформления заказа нужен аккаунт Ozon ID';
    }

    return {
        caption,
        rightContent,
    };
};
